import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [ 
        //首页
        {
            path: '/',
            name:'/',
            component: () => import("@/pages/Home/HomeIndex.vue"),
        },
        //工业厂房
        {
            path: '/plant',
            name:'/plant',
            component: () => import("@/pages/Home/PlantIndex.vue")
        },
        //办公楼宇
        {
            path: '/building',
            name:'/building',
            component: () => import("@/pages/Home/buildingIndex.vue")
        },
        //商业网点
        {
            path: '/business',
            name:'/business',
            component: () => import("@/pages/Home/businessIndex.vue")
        },
        //电子沙盘
        {
            path: '/sand',
            name:'/sand',
            component: () => import("@/pages/Home/sandIndex.vue")
        },
        //营商环境
        {
            path: '/atmosphere',
            name:'/atmosphere',
            component: () => import("@/pages/Home/atmosphereIndex.vue")
        },
        //联系我们
        {
            path: '/contact',
            name:'/contact',
            component: () => import("@/pages/Home/contactIndex.vue")
        },
        //登录
        {
            path: '/login',
            name:'/login',
            component: () => import("@/pages/Home/LogIn.vue")
        },
        //我的账户
        {
            path: '/account',
            name:'/account',
            component: () => import("@/pages/Home/accountIndex.vue")
        },
        //我的收藏
        {
            path: '/collect',
            name:'/collect',
            component: () => import("@/pages/Home/collectIndex.vue")
        },
        //浏览记录
        {
            path: '/record',
            name:'/record',
            component: () => import("@/pages/Home/recordIndex.vue")
        },
        //报表订单
        {
            path: '/order',
            name:'/order',
            component: () => import("@/pages/Home/orderIndex.vue")
        },
        //系统设置
        {
            path: '/set',
            name:'/set',
            component: () => import("@/pages/Home/setIndex.vue")
        },
        //新闻详情
        {
            path: '/singleNews',
            name:'/singleNews',
            component: () => import("@/pages/Home/SingleNews.vue")
        },
        //详情
        {
            path: '/details',
            name:'/details',
            component: () => import("@/pages/Home/detailsIndex.vue")
        },
        //营商环境更多
        {
            path: '/paxton',
            name:'/paxton',
            component: () => import("@/pages/Home/PaxtonIndex.vue")
        },
        //
        // {
        //     path: '/products',
        //     name:'/products',
        //     component: () => import("@/pages/Home/Index.vue")
        // },
          //
        // {
        //     path: '/products',
        //     name:'/products',
        //     component: () => import("@/pages/Home/Index.vue")
        // },
    ]
})



export default router;